"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectUsersEdit = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Checkbox = require("../form/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _projects = require("../../redux/modules/projects");

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectUsersEdit = exports.ProjectUsersEdit = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectUsersEdit, _Component);

  function ProjectUsersEdit(props) {
    (0, _classCallCheck3.default)(this, ProjectUsersEdit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProjectUsersEdit.__proto__ || (0, _getPrototypeOf2.default)(ProjectUsersEdit)).call(this, props));

    _this.state = {
      value: "",
      email_list: " ",
      error_email: " ",
      buttonDisabled: true
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.addEmail = _this.addEmail.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ProjectUsersEdit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var user = this.props.user;

      if (user) {}
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.company && this.props.company) {}
    }
  }, {
    key: "render",
    value: function render() {
      var userList = this.props.userList;
      var _props$fields = this.props.fields,
          is_admin = _props$fields.is_admin,
          is_project_editor = _props$fields.is_project_editor,
          is_driver = _props$fields.is_driver;


      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "form",
            { onSubmit: this.handleSubmit },
            _react2.default.createElement(
              "div",
              { className: "col col-sm-6 input-group" },
              this.showAddedEmail(),
              "Kirjoita projektiin kutsuttavien henkil\xF6iden s\xE4hk\xF6postiosoitteet pilkulla erotettuna.",
              _react2.default.createElement("textarea", {
                type: "text",
                value: this.state.value,
                onChange: this.handleChange
              })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-sm-6 input-group" },
              "Valitse projektiin kutsuttavan henkil\xF6n k\xE4ytt\xF6oikeustaso: ",
              _react2.default.createElement("br", null),
              "Yll\xE4pit\xE4j\xE4 pystyy hallinnoimaan koko projektia, k\xE4ytt\xE4j\xE4 pystyy vain lis\xE4\xE4m\xE4\xE4n ja muokkaamaan ilmoituksia.",
              _react2.default.createElement(_Checkbox2.default, {
                id: "is_project_admin",
                label: "Yll\xE4pit\xE4j\xE4",
                fieldProps: is_admin
              }),
              _react2.default.createElement(_Checkbox2.default, {
                id: "is_project_editor",
                label: "Projektik\xE4ytt\xE4j\xE4",
                fieldProps: is_project_editor
              })
            ),
            _react2.default.createElement("input", {
              type: "submit",
              className: "button button-set-width",
              value: "Lis\xE4\xE4"
            })
          )
        )
      );
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this2 = this;

      var id = this.props.params.id;
      var _props$fields2 = this.props.fields,
          is_admin = _props$fields2.is_admin,
          is_project_editor = _props$fields2.is_project_editor,
          is_driver = _props$fields2.is_driver;

      if (!is_admin.value & !is_project_editor.value) {
        alert("Valitse vähintään yksi käyttöoikeustaso.");
        event.preventDefault();
      } else {
        var emailsToSent = this.checkAddedEmails(this.state.value);
        console.info("emailsToSent", emailsToSent);
        if (emailsToSent) {
          //  let dataToSent = [];
          emailsToSent.forEach(function (email) {
            var dataToSent = {};
            dataToSent.projectId = id;
            dataToSent.email = email.replace(/\n/g, "").toLowerCase();
            dataToSent.is_admin = !!is_admin.value;
            dataToSent.is_project_editor = !!is_project_editor.value;
            dataToSent.is_driver = false;

            _this2.addEmail(dataToSent);
          });
        }
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({ value: event.target.value });
    }
  }, {
    key: "addEmail",
    value: function addEmail(data) {
      var _props = this.props,
          user = _props.user,
          addProjectUserEmail = _props.addProjectUserEmail;

      addProjectUserEmail(user.id, data);
    }
  }, {
    key: "showAddedEmail",
    value: function showAddedEmail() {
      var userEmail = this.props.userEmail;

      if (userEmail) {
        return _react2.default.createElement(
          "div",
          { className: "voucher-order-cart" },
          _react2.default.createElement(
            "p",
            null,
            " ",
            userEmail,
            " added"
          )
        );
      }
    }
  }, {
    key: "checkAddedEmails",
    value: function checkAddedEmails(emailsText) {
      var _this3 = this;

      var splitedEmail = emailsText.split(",");
      var errorEmails = "";

      splitedEmail.forEach(function (email) {
        if (!_this3.validateEmail(email)) {
          errorEmails = errorEmails + "\n" + email;
        }
      });

      if (errorEmails == "") {
        return splitedEmail;
      } else {
        alert("Tarkista antamasi sähköpostit " + errorEmails);
        return false;
      }
    }
  }, {
    key: "addEmailUser",
    value: function addEmailUser(emailsText) {
      var userEmails = {};
      var errorEmails = [];
      var splitedEmail = emailsText.split(",");
      for (i = 0; i < splitedEmail.length; i++) {
        if (!this.validateEmail(splitedEmail[i])) {
          errorEmails = splitedEmail[i];
        }
      }
    }
  }, {
    key: "validateEmail",
    value: function validateEmail(address) {
      var regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (regexEmail.test(address)) {
        return true;
      } else {
        return false;
      }
    }
  }]);
  return ProjectUsersEdit;
}(_react.Component), _class.propTypes = {
  addProjectUserEmail: _react.PropTypes.func.isRequired,
  fields: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object,
  company: _react.PropTypes.object,
  userList: _react.PropTypes.array,
  userEmail: _react.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    userEmail: state.projects.userEmail
  };
}, {
  addProjectUserEmail: _projects.addProjectUserEmail
})(ProjectUsersEdit);


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/projects/ProjectUsersEdit.js
 ** module id = 1178
 ** module chunks = 0
 **/